const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class TestApi {
  async getTestByModuloId(id_modulo) {
    const res = await fetch(api(`test/${id_modulo}`));
    if (!res.ok) throw new Error(`getTestByModuloId: ${res.status}`);
    const rows = await res.json();
    return rows[0] || null;
  }

  async insertTest(data) {
    const res = await fetch(api('test'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`insertTest: ${res.status}`);
    return res.json();
  }

  async deleteTest(id) {
    const res = await fetch(api(`test/${id}`), { method: 'DELETE' });
    if (!res.ok) throw new Error(`deleteTest: ${res.status}`);
    return { success: true };
  }
}
